import React from 'react';
import { Box } from '@mui/material';

const Ad = () => {
  return (
    <>
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          width: '100%', 
          height: '100vh'
        }}
      >
        <>Anúncio</>
      </Box>
    </>
  );
};

export default Ad;